/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const EnginuityWorkbench = lazyLoad(
  () => import('./index'),
  module => {
    return module.EnginuityWorkbench;
  },
);
